<div class="dialog-header">
  <h2 mat-dialog-title>
    {{ 'Select_Documents_tr' | translate }}
  </h2>
  <div class="dialog-header__actions">
    <button
      mat-stroked-button
      class="filter-trigger"
      data-testid="document-link-filter-button"
      [class.filter-trigger--active]="filtersApplied()"
      [matMenuTriggerFor]="filterMenu"
      [matMenuTriggerRestoreFocus]="false"
      type="button"
    >
      <mat-icon>tune</mat-icon>
      <span>{{ 'Filter_tr' | translate }}</span>
      @if (filtersApplied()) {
        <span class="filter-indicator"></span>
      }
    </button>
    <button
      mat-icon-button
      type="button"
      class="dialog-header__close"
      [matTooltip]="'close_tr' | translate"
      (click)="closeDialog()"
      aria-label="Close dialog"
    >
      <mat-icon>keyboard_double_arrow_right</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="dialog-content">
  <div class="document-card-list__hint">
    <button mat-flat-button color="primary" type="button" class="show-canvas-button" (click)="showCanvas()">
      <mat-icon>dashboard</mat-icon>
      {{ 'Show_canvas_tr' | translate }}
    </button>
    <span>
      @if (selectedCount()) {
        <span class="document-card-list__hint-count">{{ 'Selected_tr' | translate }} : {{ selectedCount() }}</span>
      }
    </span>
    <mat-slide-toggle [checked]="groupsEnabled()" (change)="groupsEnabled.set($event.checked)">
      {{ 'Show_groups_tr' | translate }}
    </mat-slide-toggle>
  </div>
  <mat-menu #filterMenu="matMenu" class="filter-menu" [overlapTrigger]="false">
    <div class="filter-menu-container" (click)="$event.stopPropagation()">
      <form class="filter-panel" [formGroup]="filters">
        <div class="filter-panel__header">
          <div class="filter-panel__title">
            @if (!filtersApplied()) {
              <mat-icon>tune</mat-icon>
            }
            <div>
              <h3>{{ 'Filter_tr' | translate }}</h3>
              <p>{{ 'Combine_filters_and_the_list_updates_instantly_tr' | translate }}</p>
            </div>
          </div>
          @if (filtersApplied()) {
            <div class="filter-panel__actions">
              <button mat-stroked-button type="button" class="filter-reset" (click)="clearFilters()">
                <mat-icon>restart_alt</mat-icon>
                {{ 'Reset_tr' | translate }}
              </button>
            </div>
          }
        </div>

        <div class="filter-grid">
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>{{ 'Search_tr' | translate }}</mat-label>
            <input matInput formControlName="search" type="search" placeholder="{{ 'Search_by_name_tr' | translate }}" />
            <button mat-icon-button matSuffix type="button" *ngIf="filters.value.search" (click)="filters.patchValue({ search: '' })">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>{{ 'Category_tr' | translate }}</mat-label>
            <mat-select formControlName="typeId">
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="typeSearchControl"
                  [placeholderLabel]="'Search_document_types_tr' | translate"
                  [noEntriesFoundLabel]="'No_document_types_found_tr' | translate"
                  [disabled]="typesLoading()"
                ></ngx-mat-select-search>
              </mat-option>
              @if (!enforcedCategory()) {
                <mat-option value="">{{ 'All_tr' | translate }}</mat-option>
              }
              @for (group of typeGroups(); track group.category) {
                <mat-optgroup>
                  <div class="group-label">
                    <span>{{ group.labelKey | translate }}</span>
                  </div>
                  @if (!typeSearchActive()) {
                    <mat-option [value]="categoryFilterValue(group.category)">
                      {{ 'All_tr' | translate }} - {{ group.labelKey | translate }}
                    </mat-option>
                  }
                  @for (type of group.types; track type.id) {
                    <mat-option [value]="type.id">{{ type.name }}</mat-option>
                  }
                </mat-optgroup>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>{{ 'Date_range_tr' | translate }}</mat-label>
            <mat-date-range-input [formGroup]="filters" [rangePicker]="picker">
              <input matStartDate formControlName="start" placeholder="{{ 'Start_tr' | translate }}" />
              <input matEndDate formControlName="end" placeholder="{{ 'End_tr' | translate }}" />
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
      </form>
    </div>
  </mat-menu>

  <div class="document-card-list">
    @if (groupsEnabled() && groupedDocuments().length) {
      <section class="linked-groups">
        @for (entry of groupedDocuments(); track entry.group.id) {
          <div class="linked-group">
            <div class="linked-group__header">
              <mat-checkbox
                [checked]="isGroupFullySelected(entry.documents)"
                [indeterminate]="isGroupPartiallySelected(entry.documents)"
                (change)="toggleGroup(entry.documents, $event.checked)"
              >
                {{ entry.group.title }}
              </mat-checkbox>
              <span>{{ entry.documents.length }} {{ 'Documents_tr' | translate }}</span>
            </div>
            <div class="linked-group__documents">
              @for (document of entry.documents; track document.id) {
                <div
                  role="button"
                  tabindex="0"
                  class="linked-group__document"
                  [class.linked-group__document--selected]="isSelected(document)"
                  (click)="selectDocument(document)"
                >
                  <mat-icon class="linked-group__select">{{ isSelected(document) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                  <span class="linked-group__preview">
                    @if (previewSrc(document); as src) {
                      <img [src]="src" [alt]="document.title" />
                      @if (!hasPreviewError(document)) {
                        <span class="preview-hover-button" (click)="viewDocument(document); $event.stopPropagation()">
                          <mat-icon>visibility</mat-icon>
                          <span>{{ 'Preview_tr' | translate }}</span>
                        </span>
                      }
                    } @else {
                      <mat-icon>insert_drive_file</mat-icon>
                    }
                  </span>
                  <span class="linked-group__body">
                    <strong>{{ document.title || document.fileName }}</strong>
                    <span>{{ document.type?.name || document.fileType }}</span>
                    <span class="linked-group__date-row">
                      {{ document.date | date }}
                      @if (hasUsages(document) && !isUsageExpanded(document)) {
                        <button type="button" class="linked-group__usage" (click)="toggleUsageList(document, $event)">
                          {{ 'show_tr' | translate }} {{ usageCount(document) }} {{ usageCountLabel(document) | translate }}
                        </button>
                      }
                    </span>
                    @if (isUsageExpanded(document)) {
                      <span class="linked-group__usage-list">
                        @for (usage of documentUsages(document); track usage.link + usage.type) {
                          <span
                            class="document-card__usage-chip"
                            [matTooltip]="usageLabel(usage)"
                            (click)="handleUsageClick(usage, $event)"
                          >
                            <mat-icon>{{ usageIcon(usage) }}</mat-icon>
                            <span>{{ usageLabel(usage) }}</span>
                          </span>
                        }
                      </span>
                    }
                  </span>
                </div>
              }
            </div>
            @if (!entry.documents.length) {
              <div class="linked-group__empty">
                {{ 'Group_has_no_documents_tr' | translate }}
              </div>
            }
          </div>
        }
      </section>
    } @else if (groupsEnabled()) {
      <div class="empty-state" role="status">
        <mat-icon>folder_off</mat-icon>
        <p>{{ 'no_document_groups_found_tr' | translate }}</p>
        <small>{{ 'no_document_groups_found_hint_tr' | translate }}</small>
      </div>
    }
    @if (!groupsEnabled() && documents().length) {
      @for (document of documents(); track document.id) {
        <div
          role="button"
          tabindex="0"
          class="document-card"
          [class.document-card--selected]="isSelected(document)"
          (click)="selectDocument(document)"
          (keydown.enter)="selectDocument(document)"
          (keydown.space)="selectDocument(document); $event.preventDefault()"
        >
          <button
            mat-icon-button
            type="button"
            class="document-card__select"
            [class.document-card__select--checked]="isSelected(document)"
            [attr.aria-pressed]="isSelected(document)"
            [matTooltip]="isSelected(document) ? ('Deselect_tr' | translate) : ('Select_tr' | translate)"
            (click)="selectDocument(document); $event.stopPropagation()"
          >
            <mat-icon>{{ isSelected(document) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
          </button>
          <span class="document-card__preview">
            @if (previewSrc(document); as src) {
              <img [src]="src" [alt]="document.title" />
            } @else if (hasPreviewError(document)) {
              <mat-icon color="warn">error</mat-icon>
            } @else {
              <mat-icon>insert_drive_file</mat-icon>
            }
            @if (previewSrc(document) && !hasPreviewError(document)) {
              <span class="preview-hover-button" (click)="viewDocument(document); $event.stopPropagation()">
                <mat-icon>visibility</mat-icon>
                <span>{{ 'Preview_tr' | translate }}</span>
              </span>
            }
          </span>
          <span class="document-card__body">
            <span class="document-card__title">{{ document.title || document.fileName }}</span>
            <span class="document-card__type">{{ document.type?.name || document.fileType }}</span>
            <span class="document-card__meta-row">
              <span class="document-card__date">{{ document.date | date }}</span>
              @if (hasUsages(document) && !isUsageExpanded(document)) {
                <button
                  type="button"
                  class="document-card__usage-link"
                  [attr.aria-label]="'show ' + usageCount(document) + ' ' + (usageCountLabel(document) | translate)"
                  (click)="toggleUsageList(document, $event)"
                >
                  {{ 'show_tr' | translate }} {{ usageCount(document) }} {{ usageCountLabel(document) | translate }}
                </button>
              }
            </span>
            @if (isUsageExpanded(document)) {
              <div class="document-card__usage-chips">
                @for (usage of documentUsages(document); track usage.link + usage.type) {
                  <span class="document-card__usage-chip" [matTooltip]="usageLabel(usage)" (click)="handleUsageClick(usage, $event)">
                    <mat-icon>{{ usageIcon(usage) }}</mat-icon>
                    <span class="usage-chip-label">{{ usageLabel(usage) }}</span>
                    <mat-icon class="usage-chip__new-tab">open_in_new</mat-icon>
                  </span>
                }
              </div>
            }
          </span>
          <span class="document-card__actions">
            <span
              [matTooltip]="
                isPendingDocument(document)
                  ? ('Document_selected_for_linking_tr' | translate)
                  : isSelected(document)
                    ? ('Document_selected_for_linking_tr' | translate)
                    : hasUsages(document)
                      ? ('Document_in_use_tr' | translate)
                      : ('Edit_tr' | translate)
              "
              [matTooltipDisabled]="false"
            >
              <button
                type="button"
                mat-stroked-button
                class="document-card__action-btn"
                [class.document-in-use]="hasUsages(document) || isSelected(document) || isPendingDocument(document)"
                [disabled]="hasUsages(document) || isSelected(document) || isPendingDocument(document)"
                [disabled]="readOnly()"
          (click)="editDocument(document, $event)"
              >
                <mat-icon>edit</mat-icon>
              </button>
            </span>
            <span
              [matTooltip]="
                isPendingDocument(document)
                  ? ('Document_selected_for_linking_tr' | translate)
                  : isSelected(document)
                    ? ('Document_selected_for_linking_tr' | translate)
                    : hasUsages(document)
                      ? ('Document_in_use_tr' | translate)
                      : ('Delete_tr' | translate)
              "
              [matTooltipDisabled]="false"
            >
              <button
                type="button"
                mat-stroked-button
                class="document-card__action-btn"
                [class.document-in-use]="hasUsages(document) || isSelected(document) || isPendingDocument(document)"
                [disabled]="hasUsages(document) || isSelected(document) || isPendingDocument(document)"
                [disabled]="readOnly()"
          (click)="deleteDocument(document, $event)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </span>
          </span>
        </div>
      }
      <mat-paginator
        [length]="total()"
        [pageSize]="pageSize()"
        [pageIndex]="pageIndex()"
        [showFirstLastButtons]="true"
        [hidePageSize]="true"
        (page)="handlePageChange($event)"
      ></mat-paginator>
    } @else if (!groupsEnabled()) {
      <div class="empty-state">
        <mat-icon>inventory_2</mat-icon>
        <p>{{ 'No_documents_match_your_filters_tr' | translate }}</p>
        <small>{{ 'Try_adjusting_search_terms_or_date_range_tr' | translate }}</small>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions data-tour="actions_linking_btn" align="end">
  <input #uploadInput type="file" accept=".pdf,.zip,image/*" multiple hidden (change)="handleUploadSelection($event)" />
  <div class="action-buttons">
    <button
        mat-flat-button
        color="primary"
        type="button"
        class="text-capitalize"
        data-testid="document-link-upload-button"
        cdkFocusInitial
        [disabled]="readOnly()"
        (click)="openUploadPicker(uploadInput)"
      >
      <mat-icon>upload</mat-icon>
      {{ 'Upload_tr' | translate }}
    </button>
    <button
        mat-flat-button
        color="accent"
        class="text-capitalize"
        type="button"
        data-testid="document-link-confirm-button"
        [disabled]="readOnly() || !selectedCount()"
        (click)="confirm()"
      >
      <mat-icon>attach_file</mat-icon>
      {{ 'link_Document_tr' | translate }}
    </button>
  </div>
</mat-dialog-actions>
